import { Button } from "@mui/material";

import { ContactForm } from "./create-contact.form";
import { useSaveData } from "../../../hooks/useSaveData";
import { contactFormSchema } from "./contact-form.schema";
import { useReactHookForm } from "../../../hooks/useReactHookForm";
import { contactApiKeyStore } from "../../../api/contact-api-key-store";
import { ReactHookForm } from "../../../components/hook-form/react-hook-form.component";
import { useAuthorize } from "../../../hooks/use-authorize";
import { UserPermissionName } from "../../../models/user-permission-name";

interface EditContactComponent {
    contactData: any;
    onClosed: () => void;
}

export const EditContactComponent = ({ contactData, onClosed }: EditContactComponent) => {
    const form = useReactHookForm({
        defaultValues: {
            ...contactData,
        },
        yupSchema: contactFormSchema,
    });

    const { isLoading, isError, error, mutateAsync } = useSaveData(contactApiKeyStore.updateContact(), () => contactApiKeyStore.getContacts());

    const submitHanlder = async (data: any) => {
        const editData = {
            ...data,
            customerID: data?.customer?.customerID,
            contactsRoleID: data?.contactRole?.contactsRoleID,
            contactsRoleName: data?.contactRole?.contactsRoleName,
            contactsNotificationIDs: data?.contactsNotificationIDs?.length > 0 ? data?.contactsNotificationIDs?.map((ps: any) => ps.notificationReportStatusID) : [],
            ppiReportStatusIDs: data?.ppiReportStatusIDs?.length > 0 ? data?.ppiReportStatusIDs?.map((ps: any) => ps.notificationReportStatusID) : [],
            susReportStatusIDs: data?.susReportStatusIDs?.length > 0 ? data?.susReportStatusIDs?.map((ps: any) => ps.notificationReportStatusID) : [],
            otherReportStatusIDs: data?.otherReportStatusIDs?.length > 0 ? data?.otherReportStatusIDs?.map((ps: any) => ps.notificationReportStatusID) : [],
            contactMappingFrom: "mastercontact"
        }
        await mutateAsync({ data: editData });
        onClosed();
    };

    const isReadOnlyPermission = useAuthorize([UserPermissionName?.READ_ONLY]);

    return (
        <ReactHookForm formName="EDIT_CONTACT_FORM" onSubmit={submitHanlder} formContextProps={form}>
            <ContactForm />
            <div style={{ paddingTop: 15 }} className="spaceBetween">
                <Button variant="outlined" style={{ width: '130px' }} onClick={onClosed}>
                    Cancel
                </Button>
                <Button
                    type="button"
                    disabled={isLoading || isReadOnlyPermission}
                    variant="contained"
                    style={{ width: '130px' }}
                    onClick={() => form.handleSubmit(submitHanlder)()}
                >
                    Save
                </Button>
            </div>
        </ReactHookForm>
    );
}